import { render, staticRenderFns } from "./Live.vue?vue&type=template&id=2732332c"
import script from "./Live.vue?vue&type=script&lang=js"
export * from "./Live.vue?vue&type=script&lang=js"
import style0 from "../transmissao/assets/global.styl?vue&type=style&index=0&prod&lang=stylus&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports